import React from 'react';

const ParentCommunicationHub = () => (
  <div style={{ padding: 6 }}>
    <h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e3a5f', marginBottom: 10 }}>Communication Hub</h1>
    <p style={{ fontSize: 14, color: '#64748b', marginBottom: 18 }}>
      Stay connected with classroom updates, messages, and family communications.
    </p>

    <div style={{ display: 'grid', gap: 18 }}>
      <section style={{ padding: 18, borderRadius: 18, background: '#f8fafc', border: '1px solid #dbeafe', boxShadow: '0 2px 8px rgba(15, 23, 42, 0.06)' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#1e3a5f', marginBottom: 12 }}>Recent and Upcoming</div>
        <div style={{ display: 'grid', gap: 12 }}>
          {[
            'Mrs. Eye posted 3 new grades for Alex.',
            'Sandy Crawley sent you a new message!',
            'Tomorrow, April 3rd is pajama day in Kaden’s class.',
          ].map((item) => (
            <div key={item} style={{ background: 'white', borderRadius: 14, padding: 14, border: '1px solid #c7d2fe', color: '#334155' }}>
              {item}
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: 18, borderRadius: 18, background: '#eef2ff', border: '1px solid #c7d2fe' }}>
        <div style={{ display: 'grid', gap: 12 }}>
          {['Report an Absence', 'Send a Message', 'Classroom Pages', 'Work Galleries', 'Photos and Videos', 'Ask a Question', 'Event List', 'Directory'].map((label) => (
            <div key={label} style={{ background: 'white', borderRadius: 12, padding: 14, border: '1px solid #e2e8f0', fontWeight: 700, color: '#1e3a5f' }}>
              {label}
            </div>
          ))}
        </div>
      </section>
    </div>
  </div>
);

export default ParentCommunicationHub;
